import React from 'react'
 import '../style/About.scss'

export default function About() {
  return (
      <section className="about-us">
          <h2>Ինչու՞ ընտրել «ARDA»-ն</h2>
          <p className="about-text">
              «ARDA» կրթական կենտրոնը հիմնադրվել է նպատակ ունենալով կրթությունը դարձնել հասանելի և կիրառելի։
              Մենք առաջնորդվում ենք անհատական մոտեցմամբ։
          </p>
          <div className="mission-vision">
              <div className="box">
                  <h4>Մեր առաքելությունը</h4>
                  <p>Զինել ուսանողներին արդիական գիտելիքներով և փորձառու մասնագետների աջակցությամբ։</p>
              </div>
              <div className="box">
                  <h4>Մեր տեսլականը</h4>
                  <p>Դառնալ առաջատար հարթակ, որտեղ տեսությունը հանդիպում է պրակտիկային։</p>
              </div>
          </div>
      </section>
  )
}
